import { DelayedComponentLoader } from "@ch/components/Loaders/ComponentLoader/DelayedComponentLoader";
import { type FC, Suspense, lazy } from "react";

const ReferAFriendPage = lazy(() => import("./ReferAFriendPage.tsx"));

const ReferAFriendPageLazy: FC = () => {
  return (
    <Suspense fallback={<DelayedComponentLoader />}>
      <ReferAFriendPage />
    </Suspense>
  );
};

export default ReferAFriendPageLazy;
